module.exports = __webpack_public_path__ + "images/help/icon-twr62-0d3c5b25f081e214128c4d241dadcdd4.png";